export default "__VITE_ASSET__C8dTwJNz__"